import React from 'react';
import { Accordion } from "react-bootstrap";
import { Table } from "bootstrap-4-react/lib/components";
import { formatNumberWithCommas } from '../../config/utils';
import Switch from "react-switch";
import PropTypes from 'prop-types';

const handleDecimalKeyDown = (evt) => {
    if (evt.ctrlKey || evt.metaKey) return;
    const allowed = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End', '.'];
    if (!allowed.includes(evt.key) && !/^\d$/.test(evt.key)) evt.preventDefault();
};

const handleSelectOnFocus = (e) => {
    const target = e.target;
    setTimeout(() => target.select(), 0);
};

const normalizeDecimalValue = (val) => {
    let normalized = val;
    if (normalized.startsWith('.')) normalized = '0' + normalized;
    if (normalized.endsWith('.')) normalized = normalized.slice(0, -1);
    return normalized;
};

const handleDecimalBlur = (e, fieldName, handleMarginValue, index, serviceIndex) => {
    const val = e.target.value;
    const normalized = normalizeDecimalValue(val);
    if (normalized !== val) handleMarginValue({ target: { value: normalized, name: fieldName } }, index, serviceIndex, true);
    else handleMarginValue(e, index, serviceIndex, true);
};

const AccordionList = (props) => {
    const { handleMarginValue, handleStatusChange, data, edit, isSeller, showCarrierToggle, handleCarrierStatusChange, disabledServiceInputs } = props;
    return (
        <Accordion className={`incomingAccordion pt-2${showCarrierToggle ? ' defaultConfigAccordion' : ''}`} defaultActiveKey={[]} alwaysOpen>
            {data && data.length > 0 && data.map((item, index) => (
                <Accordion.Item eventKey={index} key={item.id}>
                    <Accordion.Header>
                        {item.carrierCompanyName}
                        <div className="d-flex align-items-center" style={{ gap: '40px' }}>
                            {showCarrierToggle && (
                                // eslint-disable-next-line jsx-a11y/no-static-element-interactions
                                <div onClick={(e) => e.stopPropagation()} onKeyDown={(e) => e.stopPropagation()}>
                                    <Switch
                                        checked={!!item.isActive}
                                        disabled={!edit}
                                        className="switchBtn"
                                        onChange={(checked) => handleCarrierStatusChange(checked, index)}
                                    />
                                </div>
                            )}
                            <i className="fa fa-chevron-down" aria-hidden="true"></i>
                        </div>
                    </Accordion.Header>
                    <Accordion.Body className='tableFixAcodianHead'>
                        <Table className="table table-borderless carrierListingTable">
                            <thead>
                                <tr className="trow">
                                    <th className="trows-s" width={"5%"}>#</th>
                                    <th className="trows-s" width={isSeller ? "75%" : "25%"}>
                                        <div>Service</div>
                                    </th>
                                    {!isSeller && (
                                        <>
                                            <th className="trows-s alignLeft" width={"25%"}>Margin($)</th>
                                            <th className="trows-s alignLeft" width={"25%"}>Margin(%)</th>
                                        </>
                                    )}
                                    <th className="trows-s" width={"10%"}>Status</th>
                                </tr>
                            </thead>

                            <tbody>
                                {item?.services.map((serviceItem, serviceIndex) => {
                                    const isServiceDisabled = disabledServiceInputs && !serviceItem?.isActive;
                                    return (
                                    <tr key={serviceItem.id} style={isServiceDisabled ? { opacity: 0.5 } : {}}>
                                        <td className="trows-s">{serviceIndex + 1}</td>
                                        <td className="trows-s">{serviceItem.serviceName}</td>
                                        {!isSeller && (
                                            <>
                                                <td className="trows-s">
                                                    {edit ? (
                                                        <div className="d-inline-flex">
                                                            <input
                                                                className="form-control inputFilter mrginDollar"
                                                                type='text'
                                                                inputMode='decimal'
                                                                maxLength={10}
                                                                onChange={(e) => handleMarginValue(e, index, serviceIndex)}
                                                                value={serviceItem?.marginFlat}
                                                                name="marginFlat"
                                                                onKeyDown={handleDecimalKeyDown}
                                                                onFocus={handleSelectOnFocus}
                                                                onBlur={(e) => handleDecimalBlur(e, 'marginFlat', handleMarginValue, index, serviceIndex)}
                                                                disabled={isServiceDisabled}
                                                                readOnly={isServiceDisabled}
                                                            />
                                                        </div>
                                                    ) : (
                                                        <div className="d-inline-flex">
                                                            {formatNumberWithCommas(serviceItem?.marginFlat || 0)}
                                                        </div>
                                                    )}
                                                </td>
                                                <td className="alignLeft">
                                                    {edit ? (
                                                        <div className="d-inline-flex">
                                                            <input
                                                                className="form-control mrginPercent"
                                                                type='text'
                                                                inputMode='decimal'
                                                                maxLength={10}
                                                                onChange={(e) => handleMarginValue(e, index, serviceIndex)}
                                                                name="marginPercentage"
                                                                value={serviceItem?.marginPercentage}
                                                                onKeyDown={handleDecimalKeyDown}
                                                                onFocus={handleSelectOnFocus}
                                                                onBlur={(e) => handleDecimalBlur(e, 'marginPercentage', handleMarginValue, index, serviceIndex)}
                                                                disabled={isServiceDisabled}
                                                                readOnly={isServiceDisabled}
                                                            />
                                                        </div>
                                                    ) : (
                                                        <div className="d-inline-flex">
                                                            {formatNumberWithCommas(serviceItem?.marginPercentage || 0)}
                                                        </div>
                                                    )}
                                                </td>
                                            </>
                                        )}
                                        <td>
                                            <Switch
                                                key={serviceItem?.id}
                                                checked={serviceItem?.isActive}
                                                disabled={!edit}
                                                id='switchBtn'
                                                className="switchBtn"
                                                onChange={(checked) => handleStatusChange(checked, index, serviceIndex)}
                                            />
                                        </td>
                                    </tr>
                                    );
                                })}
                            </tbody>
                        </Table>
                    </Accordion.Body>
                </Accordion.Item>
            ))}
        </Accordion>
    );
}

AccordionList.propTypes = {
    handleMarginValue: PropTypes.func,
    handleStatusChange: PropTypes.func.isRequired,
    data: PropTypes.array.isRequired,
    edit: PropTypes.bool.isRequired,
    isSeller: PropTypes.bool,
    showCarrierToggle: PropTypes.bool,
    handleCarrierStatusChange: PropTypes.func,
    disabledServiceInputs: PropTypes.bool,
}

export default AccordionList;